import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/manga';

const categoryKeys = Object.keys(categoryMap);

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl whitespace-nowrap">香香漫画</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              香香漫画网，提供海量韩漫、日漫、国漫免费在线阅读服务。下拉式阅读体验，让追更变得更加轻松愉快。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">漫画分类</h4>
            <ul className="space-y-2">
              {categoryKeys.map((key) => (
                <li key={key}>
                  <Link
                    to={`/category/${key}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {categoryMap[key]}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/category/kr"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  热门推荐
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">免责声明</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@xiangxiangmh.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-customer-service-line text-primary-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 香香漫画 xiangxiangmh.com — 版权所有
          </p>
          <p className="text-xs text-foreground-400">
            本站所有漫画均来自互联网，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}